/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CommunicationRequest = {
  data: {
    name: string
    from?: string
    subject: string
    body: string
    replyTo?: string
    template?: CommunicationRequest.template
    fromName?: string
  }
}
export namespace CommunicationRequest {
  export enum template {
    BASE = 'base',
    CRONJOB = 'cronjob',
  }
}
